import { object, string, array } from "yup";
import isValidCnpj from "../../../../../utils/isValidCnpj";

export const bankCommunicationSchema = object().shape({
  bankCommunicationIsValidated: string().optional(),
  hasBankTransferFile: string()
    .required("Pagamamento via arquivo de transferência bancária é obrigatório")
    .oneOf(["1", "2"], "Selecione uma opção válida para pagamento via arquivo CNAB"),
  bankFileLayoutD1: string()
    .required("Layout D+1 é obrigatório")
    .oneOf(["1", "2"], "Selecione uma opção válida para layout D+1"),
  bankSequentialNumberRule: string()
    .required("Regra de número sequencial é obrigatória")
    .oneOf(["1", "2"], "Selecione uma opção válida para regra sequencial"),
  issueUnifiedBankFile: string()
    .required("Emissão de arquivo unificado é obrigatória")
    .oneOf(["1", "2"], "Selecione uma opção válida para emissão de arquivo unificado"),
  bankAccounts: array()
    .of(
      object().shape({
        cnpj: string()
          .required("CNPJ do Banco é obrigatório")
          .test("is-cnpj", "O valor não corresponde a um CNPJ válido", value =>
            isValidCnpj(value),
          ),
        bank: string().required("Banco é obrigatório"),
        agency: string().required("Agência do Banco é obrigatória"),
        account: string().required("Conta do Banco é obrigatória"),
        agreementCode: string().required("Código de convênio do Banco é obrigatório"),
      })
    )
    .min(1, "Adicione pelo menos um banco"),
  specificPaymentRule: string()
    .required("Regra específica de pagamento é obrigatória")
    .oneOf(["1", "2"], "Selecione uma opção válida para regra específica de pagamento"),
  specificPaymentRuleDescription: string().when("specificPaymentRule", {
    is: "1",
    then: string().required("Descreva a regra de negócio específica da conta"),
    otherwise: string().optional().nullable(),
  }),
});
